module.exports = __webpack_public_path__ + "static/media/jakarta-gray.f1f75d78.svg";